// Admin Layout Scripts

// Auto-dismiss alerts after 2 seconds
document.addEventListener("DOMContentLoaded", function () {
  const alerts = document.querySelectorAll(".alert-dismissible");
  alerts.forEach(function (alert) {
    setTimeout(function () {
      const bsAlert = new window.bootstrap.Alert(alert);
      bsAlert.close();
    }, 2000);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-branch-metadata-editor]").forEach((editor) => {
    const rowsContainer = editor.querySelector("[data-branch-metadata-rows]");
    const template = editor.querySelector("[data-branch-metadata-template]");
    const jsonInput = editor.querySelector("[data-branch-metadata-json]");
    const addButton = editor.querySelector("[data-branch-metadata-add]");
    const form = editor.closest("form");

    if (!rowsContainer || !template || !jsonInput || !addButton || !form) return;

    const coerceValue = (rawValue) => {
      const value = rawValue.trim();

      if (value === "") return "";
      if (value === "true") return true;
      if (value === "false") return false;
      if (value === "null") return null;
      if (/^-?(0|[1-9]\d*)(\.\d+)?$/.test(value)) return Number(value);

      try {
        if (value.startsWith("{") || value.startsWith("[")) return JSON.parse(value);
      } catch (_error) {
        return rawValue;
      }

      return rawValue;
    };

    const syncJson = () => {
      const metadata = {};

      rowsContainer.querySelectorAll("[data-branch-metadata-row]").forEach((row) => {
        const keyInput = row.querySelector("[data-branch-metadata-key]");
        const valueInput = row.querySelector("[data-branch-metadata-value]");
        const key = keyInput?.value.trim();

        if (!key) return;

        metadata[key] = coerceValue(valueInput?.value || "");
      });

      jsonInput.value = JSON.stringify(metadata);
    };

    const addRow = () => {
      rowsContainer.appendChild(template.content.cloneNode(true));
      syncJson();
    };

    addButton.addEventListener("click", addRow);

    rowsContainer.addEventListener("input", (event) => {
      if (event.target.matches("[data-branch-metadata-key], [data-branch-metadata-value]")) {
        syncJson();
      }
    });

    rowsContainer.addEventListener("click", (event) => {
      const removeButton = event.target.closest("[data-branch-metadata-remove]");
      if (!removeButton) return;

      removeButton.closest("[data-branch-metadata-row]")?.remove();
      syncJson();
    });

    form.addEventListener("submit", syncJson);
    syncJson();
  });
});
